import React from 'react'
import { Redirect } from 'react-router'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const Login = WithErrorBoundary(
  'Login',
  'Error en Login',
  React.lazy(() => import('./Login')),
)
const Inicio = WithErrorBoundary(
  'Dashboard',
  'Error en Dashboard',
  React.lazy(() => import('./Inicio')),
)
const Welcome = WithErrorBoundary(
  'Dashboard',
  'Error en Dashboard',
  React.lazy(() => import('./Welcome')),
)
const RestablecerContrasenia = WithErrorBoundary(
  'Restablecer contraseña',
  'Error en Restablecer contraseña',
  React.lazy(() => import('./restablecer-contrasenia/MainRestablecerContrasenia')),
);

const RecuperarContrasenia = WithErrorBoundary(
  'Recuperar Contrasenia',
  'Error en Recuperar Contrasenia',
  React.lazy(() => import('./recuperar-contrasenia/MainRecuperarContrasenia')),
);

const redirectToHome = () => <Redirect to={{ pathname: '/inicio' }}/>

export default {
  path: '/',
  name: 'Home',
  childRoutes: [
    { path: 'inicio', name: 'Inicio', component: Inicio },
  ],
}
